<template>
<div class="page_adressAdd">
    <div class="adress_form">
        <div class="item">
            <div class="item_l">收货人</div>
            <div class="item_r">
                <van-field v-model="name" placeholder="请填写收货人姓名" />
            </div>
        </div>
        <div class="item">
            <div class="item_l">手机号</div>
            <div class="item_r">
                <van-field v-model="phoneNumber" type="tel" placeholder="请填写收货人手机号" />
            </div>
        </div>
        <div class="item">
            <div class="item_l">选择地区</div>
            <div class="item_r" @click="areaPicker=true">
                <van-field v-model="area" placeholder="请选择地区" readonly/>
            </div>
        </div>
        <div class="item">
            <div class="item_l">详细地址</div>
            <div class="item_r">
                <van-field v-model="street" placeholder="市县、乡镇、街道、楼牌号等" />
            </div>
        </div>
    </div>
    <div class="default_adress">
        <div class="txt">设置默认地址</div>
        <div class="default_r">
            <van-switch v-model="checked" />
        </div>
    </div>
    <div class="action_wrap">
        <div class="action" @click="saveAddress">保存并使用</div>
    </div>
    <!-- 地区弹层 -->
    <van-popup v-model="areaPicker" position="bottom">
        <van-area :area-list="areaList" @confirm="confrimArea" @cancel="areaPicker=false"/>
    </van-popup>
</div>
</template>

<script>
import Vue from 'vue';
import Field from 'vant';
import router from "../../../../.././router";
import {
    LOGOUT,
    LOGIN
} from "../../../../.././vuex/mutation_types";
import Bridge from '../../../../.././vuex/bridge.js'
Vue.prototype.$bridge = Bridge
var userAgent = navigator.userAgent
export default {
    data() {
        return {
            publicPath: process.env.BASE_URL,
            checked: true, // 是否默认
            name: '',
            phoneNumber: '',
            street: '',
            area: '',
            area_name1: '',//省
            area_name2: '',//市
            area_name3: '',//区
            areaList: {},
            areaPicker: false,
            addressId: this.$route.query.addressId,
            token: ''
        };
    },
    created: function () {
        if ( userAgent && userAgent.indexOf('shidaijiyi') != -1 ) {
            //设置导航栏
            var params = {'data':{'naviTitle':'新增收货地址'}}
            this.$bridge.callhandler('sdjy://navigation/style', params, (data) => {

            })
            //获取用户信息
            var memberParams = {
                'data': {
                }
            }
            this.$bridge.callhandler('sdjy://member/memberInfo', memberParams, (data) => {
                if (data.code == 200) {
                    this.token = data.result.token
                    this.getAddressDetail()
                }
            })
            //注册方法，客户端重新进入页面刷新数据
            this.$bridge.registerhandler('sdjy://common/refreshPage', (data, responseCallback) => {
                // alert(JSON.stringify(data));
                responseCallback(data)
            })
        } else {
            this.token = this.$store.getters.token
            this.getAddressDetail()
        }
        console.log('this.addressId:'+this.addressId)
        this.getAreaData()
        
    },
    methods: {
        getAreaData() {
            var params = {
            }
            this.$api.address.areaList(params).then(res=>{
                if (res.code == 200) {
                    var area = JSON.parse(res.result)
                    this.areaList = area.areaList
                    console.log(this.areaList)
                } else {
                    this.$toast(res.message)
                }
            })
        },
        getAddressDetail() {
            if (this.addressId == null || this.addressId == undefined || this.addressId == '' ) {
                return
            }
            window.document.title = '编辑收货地址'
            var params = {
                token: this.token,
                address_id: this.addressId,
            }
            this.$api.address.addressDetail(params).then(res=>{
                if (res.code == 200) {
                    var data = res.result
                    this.name = data.person
                    this.phoneNumber = data.phone
                    this.street = data.address
                    if (data.default > 0) {
                        this.checked = true
                    } else {
                        this.checked = false
                    }
                    this.area_name1 = data.area_code1
                    this.area_name2 = data.area_code2
                    this.area_name3 = data.area_code3
                    this.area = data.area_name1+data.area_name2+data.area_name3
                } else {
                    this.$toast(res.message)
                }
            })
        },
        // 确认选中地区
        confrimArea(data){
            console.log(data)
            this.areaPicker = false;
            var area = ''
            for (let i = 0; i < data.length; i++) {
                const item = data[i];
                if (i == 0) {
                    this.area_name1 = item.code
                } else if (i == 1) {
                    this.area_name2 = item.code
                } else if (i == 2) {
                    this.area_name3 = item.code
                }
                area += item.name
            }
            this.area = area
        },
        saveAddress() {
            if (this.name == null || this.name == undefined || this.name == '') {
                this.$toast('请填写收货人姓名')
                return
            }
            if (this.phoneNumber == null || this.phoneNumber == undefined || this.phoneNumber == '') {
                this.$toast('请填写收货人手机号')
                return
			}
			if (!(/^1[3456789]\d{9}$/.test(this.phoneNumber))) {
                this.$toast('请填写合法的手机号')
                return
            }
            if (this.street == null || this.street == undefined || this.street == '') {
                this.$toast('请填写收货人地址')
                return
            }
            if (this.area_name1 == null || this.area_name1 == undefined || this.area_name1 == '') {
                this.$toast('请选择收货人地区')
                return
            }
            if (this.addressId == null || this.addressId == undefined || this.addressId == '' ) {
                this.addAddressAction()
            } else {
                this.editAddressAction()
            }
            
        },
        addAddressAction() {
            var params = {
                token: this.token,
                person: this.name,
                phone: this.phoneNumber,
                address: this.street,
                default: this.checked?1:0,
                area_name1: this.area_name1,
                area_name2: this.area_name2,
                area_name3: this.area_name3,
            }
            this.$api.address.addAddress(params).then(res=>{
                if (res.code == 200) {
                    this.$toast(res.message)
                    if ( userAgent && userAgent.indexOf('shidaijiyi') != -1 ) {
                        //返回上级页面
                        var params = {'data':{}}
                        this.$bridge.callhandler('sdjy://public/back', params, (data) => {

                        })
                    } else {
                        this.$router.back()
                    }
                    
                } else {
                    this.$toast(res.message?res.message:res.msg)
                }
            })
        },
        editAddressAction() {
            var params = {
                token: this.token,
                address_id: this.addressId,
                person: this.name,
                phone: this.phoneNumber,
                address: this.street,
                default: this.checked?1:0,
                area_name1: this.area_name1,
                area_name2: this.area_name2,
                area_name3: this.area_name3,
            }
            console.log(params)
            this.$api.address.editAddress(params).then(res=>{
                if (res.code == 200) {
                    if ( userAgent && userAgent.indexOf('shidaijiyi') != -1 ) {
                        //设置导航栏
                        var params = {'data':{}}
                        this.$bridge.callhandler('sdjy://public/back', params, (data) => {

                        })
                    } else {
                        this.$router.back()
                    }
                } else {
                    this.$toast(res.message?res.message:res.msg)
                }
            })
        },
    }
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->

<style scoped></style>
